"use client"

import { Text } from "@/elements"
import useOutsideClick from "@/hooks/useOutsideClick"
import clsx from "clsx"
import { useState } from "react"
import { FlagIcon } from "./Flag"
import { CountryCode, MOBILE_CALLING_CODES } from "./mobileCallingCodes"
import { ChevronDownIcon } from "@/icons/outline"
import * as Popover from "@radix-ui/react-popover"

const CountryCodeSelector = ({ value, setValue }: { value: CountryCode; setValue: (code: CountryCode) => void }) => {
  const keys = objectKeys(MOBILE_CALLING_CODES)

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <div className={clsx("flex h-full cursor-pointer flex-row items-center justify-center gap-x-2")}>
          <FlagIcon countryCode={MOBILE_CALLING_CODES[value].flag} />
          <ChevronDownIcon height={24} width={24} className="stroke-bg-3" />
        </div>
      </Popover.Trigger>
      <Popover.Content
        align="start"
        className={clsx(
          "duration-250 border-1 shadow-filter-button opacity-1 pointer-events-auto absolute left-0 top-full z-30 mt-2 flex max-h-[300px] w-[300px] flex-col gap-y-1 overflow-hidden overflow-y-auto rounded-md border border-fg-4 bg-bg-1 px-2 py-2 transition-opacity ease-out"
        )}>
        {keys.map((key, index) => {
          const active = key === value
          return (
            <div
              className={clsx(
                "flex cursor-pointer flex-row items-center gap-x-2 rounded-sm p-[2px] pl-[6px] hover:bg-bg-2",
                {
                  "bg-bg-1": active,
                }
              )}
              key={index}
              onClick={() => {
                setValue(key)
              }}>
              <FlagIcon countryCode={MOBILE_CALLING_CODES[key].flag} />
              <Text variant="label">{MOBILE_CALLING_CODES[key].country}</Text>
            </div>
          )
        })}
      </Popover.Content>
    </Popover.Root>
  )
}

const objectKeys = <T extends object>(obj: T) => {
  return Object.keys(obj) as Array<keyof T>
}

export default CountryCodeSelector
